<template>
<!-- 管理员菜单 -->
 <div   class="page">
     <Layout>
         <HeaderBox class="headerbox"></HeaderBox>
         <Layout>
  
                <Sider :theme="theme2" ref="side1" hide-trigger collapsible :collapsed-width="78" v-model="isCollapsed"  id="navLeft" >
                    <Menu active-name="projectAdmin" width="auto" :class="menuitemClasses" accordion :open-names="[menuData[0].name]"  >
                        <MenuGroup   v-if="item.jurisdiction" v-for="(item,index) in menuData" :key="index" :title="item.label">
                            <MenuItem class="navside" v-for="(obj,index) in item.menuitems" :key="index" :name="obj.name" >
                                <router-link v-if="!obj.tgzxs || tgzxs" :to="'/'+obj.name" exact >
                                    <Icon :type="obj.icon"></Icon>
                                    <span>{{obj.label}}</span>
                                </router-link>
                            </MenuItem>
                        </MenuGroup>
                    </Menu>
                </Sider>
                <Layout style="position: relative;" :style="{marginLeft: '210px',marginTop:'90px'}">
                    <Breadcrumb :style="{margin: '10px',fontSize:'12px'}" separator="/">
                            <BreadcrumbItem>{{parentTitle}}</BreadcrumbItem>
                            <BreadcrumbItem>{{childTitle}}</BreadcrumbItem>
                    </Breadcrumb>
                    <Content :style="{padding: '24px', background: '#fff'}"> 
                      
                        <router-view/>
                    </Content> 
                </Layout>  
            </Layout>
        <Footer class="footer">
           <p>中国田径协会©版权所有 本系统由深圳市菲普莱体育发展有限公司提供技术支持</p>
                <p>
                    <span>官方网站：<a href="http://www.fairplay.com.cn/" target="_new">www.fairplay.com.cn</a></span>
                    <span>技术支持：0755-86379837</span>
                   <span>建议使用谷歌浏览器</span>
                </p>
                                <p><a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备18040857号-1</a></p>


        </Footer>  
     </Layout>
     
 </div>
</template>

<script>
import HeaderBox from '@/public/header/'
// 修改密码


// 运动会列表

export default {
 data() {
    return {
        theme2: 'primary',
        isCollapsed: false,
        // 侧边导航数据
        menuData:[  

            {
                label:'赛前设置',
                name:"sportermeeting",
                icon:"ios-home",
                jurisdiction:false,
                menuitems:[  
                    {
                        name:'sportermeeting',
                        label:'运动会管理',
                        icon:"ios-options"
                    },
                    {
                        name:'sportermeetingMerge',
                        label:'合并运动会管理',
                        icon:"md-repeat"
                    },
                ]  
            },
            {
                label:'获奖证书管理',
                name:"List",
                icon:"md-print",
                jurisdiction:false,
                menuitems:[  
                    {
                        name:'List',
                        label:'证书打印',
                        icon:"md-print"
                    },
                ]  
            },
        
        ],
    }
 },
 components: {
     HeaderBox,
 },

 computed:{
     parentTitle()
     {
         return this.$store.state.crumbs.parentRouter
     },
     childTitle()
     {
         return this.$store.state.crumbs.childRouter
     },
    menuitemClasses () {
        return [
            'menu-item',
            this.isCollapsed ? 'collapsed-menu' : ''
        ]
    }
 },
 methods:{  
 },
 created () {
    this.menuData.map((v,k)=>{
        if(k<(this.menuData.length))
        {
            if(localStorage.authorities.indexOf(this.$PlugIn.role.roleAwardAdmin)!=-1)
            {
                if(this.menuData[k].label==='获奖证书管理')
                {
                    
                    this.menuData[k].jurisdiction = true;
                }else{
                    this.menuData[k].jurisdiction =  false;
                }
            }else if(localStorage.authorities.indexOf(this.$PlugIn.role.admin)!=-1){
                this.menuData[k].jurisdiction = true;
            }
            else if(localStorage.authorities.indexOf(this.$PlugIn.role.print)!=-1){
                if(this.menuData[k].label==='获奖证书管理')
                {
                    
                    this.menuData[k].jurisdiction = true;
                }else{

                    this.menuData[k].jurisdiction =  false;
                }
            }else{
                
                if(this.menuData[k].label==='获奖证书管理')
                {
                    
                    this.menuData[k].jurisdiction = false;
                }else{

                    this.menuData[k].jurisdiction =  true;
                }
            }
            // this.menuData[k].jurisdiction =  true;
        }
    });
 },
 mounted(){
  
 },
}
</script>
<style scoped lang="less">

 .layout{
        border: 1px solid #d7dde4;
        background: #f5f7f9;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
    }
    .layout-header-bar{
        background: #fff;
        box-shadow: 0 1px 1px rgba(0,0,0,.1);
    }
    .layout-logo-left{
        width: 90%;
        height: 30px;
        background: #5b6270;
        border-radius: 3px;
        margin: 15px auto;
    }
    .menu-icon{
        transition: all .3s;
        position: relative;
        top: -15px;
        left: -20px;
    }
    .rotate-icon{
        transform: rotate(-90deg);
    }
    .menu-item span{
        display: inline-block;
        overflow: hidden;
        width: auto;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
        transition: width .2s ease .2s;
    }
    .menu-item i{
        transform: translateX(0px);
        transition: font-size .2s ease, transform .2s ease;
        vertical-align: middle;
        font-size: 16px;
    }
    .collapsed-menu span{
        width: 0px;
        transition: width .2s ease;
    }
    .collapsed-menu i{
        transform: translateX(5px);
        transition: font-size .2s ease .2s, transform .2s ease .2s;
        vertical-align: middle;
        font-size: 22px;
    }
.ivu-layout-sider{
    background: #fff !important;
}
.footer{
    text-align: center;
    line-height: 25px;
    font-size: 12px;
    span{
        margin-left: 15px;
    }
}
.menuIcon{
    font-size: 24px;
    margin: 0px 20px;
    position: absolute;
    top: 22px;
    left: 10px;
}
.ivu-menu-item{
    color: #fff;
}
.navside{
    a{
        display: inline-block;
        width: 100%;
        padding: 15px;
        color: #30a5ff;
        text-indent: 10px;
    }
    .router-link-active{ 
        background-color: #fff;
        color: #30a5ff;
    }
}
</style>



// WEBPACK FOOTER //
// src/public/menuLeft/index.vue